import { z } from 'zod';
/**
 * The one SSE event shape. There is no journal replay: PostgreSQL is authoritative,
 * the browser opens the stream, reads a REST snapshot, then applies only events
 * newer than that snapshot.
 */
export const StudioEventSchema = z.object({
    resource: z.string().min(1),
    id: z.string().min(1),
    version: z.number().int().nonnegative(),
    state: z.string().nullable(),
    at: z.string().min(1),
});
export const EVENTS_PATH = '/api/v1/events';
//# sourceMappingURL=events.js.map